<ng-content></ng-content>
@if (blocked) {
<div class="sg-blockable-overlay" [ngClass]="_blockerStyle + '-' + _blockerDirection" [style.background]="_overlayColor">
  <div>
    @switch (_blockerStyle) { @case ('progressBar') {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    } @default {
    <mat-spinner></mat-spinner>
    } }
  </div>
  @if (blockMessage) {
  <h1>{{ blockMessage }}</h1>
  }
</div>
}
